// extracted by extract-css-chunks-webpack-plugin
module.exports = {"newsletter-signup-widget":"newsletter-signup-widget","EmailCapture":"EmailCapture","EmailForm":"EmailForm"};